import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Button,
  FormGroup,
  Chip,
  Box
} from "@mui/material";
import RichTextEditor from "./RichTextEditor";

export default function DynamicForm({ config, onSubmit  }) {
  const [formData, setFormData] = useState({});
  
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (name, option) => {
    setFormData((prev) => {
      const current = prev[name] || [];
      if (current.includes(option)) {
        return { ...prev, [name]: current.filter((o) => o !== option) };
      } else {
        return { ...prev, [name]: [...current, option] };
      }
    });
  };

  const handleTagsKeyPress = (e, name) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      e.preventDefault();
      const newTag = e.target.value.trim();
      setFormData((prev) => {
        const current = prev[name] || [];
        if (!current.includes(newTag)) {
          return { ...prev, [name]: [...current, newTag] };
        }
        return prev;
      });
      e.target.value = '';
    }
  };

  const handleRemoveTag = (name, tag) => {
    setFormData((prev) => ({
      ...prev,
      [name]: (prev[name] || []).filter((t) => t !== tag)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      {config.map((field) => {
        switch (field.type) {
          case "text":
            return (
              <TextField
                key={field.name}
                label={field.label}
                required={field.required}
                fullWidth
                margin="normal"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
          case "textarea":
            return (
              <TextField
                key={field.name}
                label={field.label}
                multiline
                rows={4}
                fullWidth
                margin="normal"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
          case "select":
            return (
              <Select
                key={field.name}
                fullWidth
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
                displayEmpty
              >
                <MenuItem value="">
                  <em>Select {field.label}</em>
                </MenuItem>
                {field.options.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            );
          case "checkbox":
            return (
              <FormControlLabel
                key={field.name}
                control={
                  <Checkbox
                    checked={formData[field.name] || false}
                    onChange={(e) => handleChange(field.name, e.target.checked)}
                  />
                }
                label={field.label}
              />
            );
          case "date":
            return (
              <TextField
                key={field.name}
                label={field.label}
                type="date"
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
          case "number":
            return (
              <TextField
                key={field.name}
                label={field.label}
                type="number"
                fullWidth
                margin="normal"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
          case "email":
            return (
              <TextField
                key={field.name}
                label={field.label}
                type="email"
                fullWidth
                margin="normal"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
              />
            );
            case "multiCheckbox":
            return (
              <FormGroup key={field.name}>
                <label>{field.label}</label>
                {field.options.map((opt) => (
                  <FormControlLabel
                    key={opt}
                    control={
                      <Checkbox
                        checked={(formData[field.name] || []).includes(opt)}
                        onChange={() => handleCheckboxChange(field.name, opt)}
                      />
                    }
                    label={opt}
                  />
                ))}
              </FormGroup>
            );
           case "richtext":
            return (
              <div key={field.name} style={{ margin: "20px 0" }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  {field.label}
                </label>
                <RichTextEditor
                  value={formData[field.name] || ''}
                  onChange={(val) => handleChange(field.name, val)}
                />
              </div>
            );
          case "tags":
            return (
              <Box key={field.name} sx={{ margin: "16px 0" }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  {field.label}
                </label>
                <TextField
                  fullWidth
                  placeholder={field.placeholder || "Add items and press Enter"}
                  margin="normal"
                  onKeyPress={(e) => handleTagsKeyPress(e, field.name)}
                  size="small"
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
                  {(formData[field.name] || []).map((tag, index) => (
                    <Chip
                      key={index}
                      label={tag}
                      onDelete={() => handleRemoveTag(field.name, tag)}
                      color="primary"
                      variant="outlined"
                    />
                  ))}
                </Box>
              </Box>
            );
            case "file":
            return (
              <Box key={field.name} sx={{ margin: "16px 0" }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  {field.label}
                </label>

                <input
                  type="file"
                  accept={field.fileType === "image" ? "image/*" : "*"}
                  multiple={field.multiple || false}
                  onChange={(e) => {
                    const files = e.target.files;

                    if (!files) return;

                    // ✅ FIX HERE
                    const value = field.multiple ? files : files[0];

                    handleChange(field.name, value);
                  }}
                />
              </Box>
            );

          default:
            return null;
        }
      })}
      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        Submit
      </Button>
    </form>
  );
}